export const appUrl = ``;

export const CARD_INSERTED_STATUS = ["FOUND", "READING", "CARD_NOT_GENUINE", "CARD_EXPIRED", "SCANNED"];
export const CARD_REMOVED_STATUS = ["READING_ERROR", "ERROR", "NOCARD", "REMOVED", "NO_SERVICES", null, undefined];
export const ADAPTER_ERROR_STATUS = [
    "ERROR",
    "TIMEOUT",
    "KEYRING_EXCEPTION",
    "KEYRING_FILE_EXCEPTION",
    "PAIRING_KEYS_EXCEPTION",
    "PAIRING_KEYS_FOUND_ERROR",
    "PAIRING_KEYS_NOT_FOUND",
    "DEVICE_PAIRING_ERROR",
    "PAIRING_KEY_SAVE_ERROR",
    "PAIRING_ERROR",
    "NOT_PAIRED",
    "SESSION_ERROR",
    "DISCONNECTED",
    null,
    undefined
];
export const ADAPTER_CONECTED_STATUS = ["SESSION_CREATED", "PAIRED", "CONNECTING", "CONNECTED", "PAIRING_KEYS_FOUND"];
